export default __webpack_public_path__ + "static/media/landing1.8eacde40.jpg";